// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-list-row--light{opacity:.6}", "",{"version":3,"sources":["webpack://./client/modules/common/dumb/tables/table-list/components/tableListRow/tableListRow.css"],"names":[],"mappings":"AACC,uBACC,UACD","sourcesContent":[".table-list-row {\n\t&--light {\n\t\topacity: 0.6;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
